import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, Theme, useMediaQuery } from '@mui/material';
import { FC } from 'react';
import { addOrdinalSuffix } from '../../utils';

export interface ISelectOptions {
	value?: string | number | readonly string[];
	label: string | number;
	[key: string]: string | number | readonly string[] | boolean | null | undefined;
}

interface IProps {
	data: ISelectOptions[];
	onChange: (value: unknown) => void;
	value?: string;
	label: string;
	id?: string;
	name?: string;
	error?: boolean;
	modal?: boolean;
	placeholder?: string;
	isDisabled?: boolean;
	daySuffix?: boolean;
	isTime?: boolean;
}

const Dropdown: FC<IProps> = ({ data, onChange, id, error, label, modal, isDisabled, daySuffix, isTime, ...rest }) => {
	const handleChange = (event: SelectChangeEvent) => {
		onChange(event.target.value);
	};

	const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

	return (
		<FormControl error={error} sx={{ width: modal && !isMobile ? '90%' : '100%' }}>
			<InputLabel id={`${id ?? ''}-select-label`}>{label}</InputLabel>
			<Select
				{...rest}
				id={id}
				label={label}
				labelId={`${id ?? ''}-select-label`}
				onChange={handleChange}
				disabled={isDisabled}
				sx={
					isTime
						? {
								backgroundColor: 'white',
								'& .MuiOutlinedInput-notchedOutline': {
									borderColor: 'rgba(0, 0, 0, 0.23)',
								},
							}
						: {}
				} // MUI doesn't permit custom variants for MuiSelect
			>
				<MenuItem key='disabled-select' disabled value=''>
					<em>{label || 'Select Option'}</em>
				</MenuItem>
				{data.length > 0 &&
					data.map((x) => (
						<MenuItem key={x.label} value={x.value}>
							{!daySuffix ? x.label : `${addOrdinalSuffix(Number(x.label))}`}
						</MenuItem>
					))}
			</Select>
		</FormControl>
	);
};

export default Dropdown;
